import ChatSection from '../components/ChatSection';

const Chat = () => {
  return <ChatSection />;
};

export default Chat;
